module.exports = __webpack_public_path__ + "img/np.d2fe38d4.svg";